// ----------------------------------------------------------------------

export const company = [
  'Alex Kueh',
];
